import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import './Popup.css'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import { Button } from '@material-ui/core'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

const useStyles = makeStyles((theme, maxWidth) => ({
    modal: {
        display: 'flex',
        padding: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        width: '100%',
        maxWidth: '46rem',
    },
}))

// const handleScrollBehavior = () => {
//     document.body.style.position = ''
//     document.body.style.top = ''
//     document.body.style.left = ''
//     document.body.style.right = ''
//     document.body.style.width = ''

//     window.scrollTo(0, 0) // restore scroll
// }

const Popup = ({ open, handleClose, children, modaltitle, modalSize, productID, popRedirect }) => {
    const classes = useStyles()
    const history = useHistory()
    return (
        <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            disableScrollLock
            open={open}
            onClose={handleClose}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className="modal fade show custom-modal">
                        <div
                            className={`modal-dialog  ${modalSize ? 'pvModelAdjust' : 'modal-lg'}`}
                        >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">{modaltitle}</h4>
                                    {modalSize ? (
                                        <div className="rightActionIcons">
                                            <Button
                                                onClick={() => {
                                                    if (handleClose) {
                                                        handleClose()
                                                    }
                                                    popRedirect()
                                                    handleRedirectInternal(
                                                        history,
                                                        `product-View/${productID}`,
                                                    )
                                                    // handleScrollBehavior()
                                                }}
                                            >
                                                <span className="material-icons">open_in_new</span>
                                            </Button>
                                            <Button
                                                id="popup_closebutton"
                                                // className="close"
                                                onClick={handleClose}
                                            >
                                                <span className="material-icons">close</span>
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button
                                            id="popup_closebutton"
                                            className="close"
                                            onClick={handleClose}
                                        >
                                            <span className="material-icons">close</span>
                                        </Button>
                                    )}
                                </div>
                                <div className="modal-body cm-body">{children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default Popup
